import * as Yup from "yup";
import schedule from "./schedule";

const {
  formField: { schedules, notes }
} = schedule;

const validations = Yup.object().shape({
  [schedules.name]: Yup.array(),
  [notes.name]: Yup.string()
});

export default validations;
